(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("jsts"), require("ginkgoch-buffer-io"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash", "jsts", "ginkgoch-buffer-io"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("lodash"), require("jsts"), require("ginkgoch-buffer-io")) : factory(root["_"], root["jsts"], root["ginkgoch-buffer-io"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(global, function(__WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__22__) {
return 